import type { TextBlock, TextDocument } from './textDocument';

export function textBlockToPlainText(block: TextBlock): string {
  return block.runs.map((run) => run.text).join('');
}

export function isTextBlockEmpty(block: TextBlock): boolean {
  return !textBlockToPlainText(block).trim();
}

export function textDocumentToPlainText(document: TextDocument | undefined): string {
  if (!document?.blocks?.length) return '';
  return document.blocks.map(textBlockToPlainText).join('\n').replace(/\n+$/g, '');
}

export function textDocumentToLayoutPlainText(
  document: TextDocument | undefined,
  options: { preserveTrailingEmptyBlocks?: boolean } = {},
): string {
  if (!document?.blocks?.length) return '';
  const text = document.blocks.map(textBlockToPlainText).join('\n');
  return options.preserveTrailingEmptyBlocks ? text : text.replace(/\n+$/g, '');
}

export function isTextDocumentEmpty(document: TextDocument | undefined): boolean {
  return !textDocumentToPlainText(document).trim();
}
